import axios from 'axios'
import { Message } from 'element-ui';
import { getSign, createNonce } from './tool'
import qs from 'qs'
import apiKeys from './confing_key'
import { utils } from './common'

var local_base_url = 'http://10.10.1.74:8888';  // 本地
var dev_base_url  = 'https://api.dev.ysintelligent.com/talent_transaction';  //dev
var test_base_url = 'https://api.test.ysintelligent.com/talent_transaction'; //test
var prod_base_url = 'https://api.ysintelligent.com/talent_transaction';

// 静态资源前缀 - oss
var local_file_prefix_url = 'https://oss.dev.yijiajiayun.com';
var dev_file_prefix_url = 'https://oss.dev.yijiajiayun.com';
var test_file_prefix_url = 'https://oss.test.yijiajiayun.com';
var prod_file_prefix_url = 'https://oss.yijiajiayun.com';

//根据环境 改变接口地址
var environmental= utils.getCurrentApi()
var resultApi={}
if(environmental=='local') {
  resultApi = {
    baseUrl: local_base_url, 
    filePrefixUrl: local_file_prefix_url
  }
}
if(environmental=='dev'){
  resultApi = {
    baseUrl: dev_base_url, 
    filePrefixUrl: dev_file_prefix_url
  }
}
if(environmental=='test'){
  resultApi = {
    baseUrl: test_base_url, 
    filePrefixUrl: test_file_prefix_url
  }
}
if(environmental=='prod'){
  resultApi = {
    baseUrl: prod_base_url, 
    filePrefixUrl: prod_file_prefix_url
  }
}

export const api = resultApi

function createRequest(baseURL, accessKey = apiKeys.accessKey, secretKey = apiKeys.secretKey) {
    // 创建axios实例
    const request = axios.create({
        // API 请求的默认前缀
        baseURL: baseURL || resultApi.baseUrl,
        // 请求超时时间
        timeout: 10000,

        headers: {
            'Accept': '*/*',
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
    })

    request.interceptors.request.use(config => {
        // 在发送请求之前做些什么
        // console.log(config)
        // console.log('config......')
        let timestamp = Date.now()
        let nonce = createNonce()

        let signObj
        if (config.method === 'get') {
            let params = switchParams(config.params)
            config.params = {
                ...params
            }
            signObj = {
                ...config.params,
                'X-validate-accessKey': accessKey,
                'X-validate-timestamp': timestamp,
                'X-validate-nonceStr': nonce
            }
        } else {
            let data = switchParams(config.data)
            config.data = {
                ...data
            }
            signObj = {
                ...config.data,
                'X-validate-accessKey': accessKey,
                'X-validate-timestamp': timestamp,
                'X-validate-nonceStr': nonce
            }
        }

        let sign = getSign(signObj, secretKey)
        // config.headers['Accept'] = '*/*'
        // config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
        config.headers['X-validate-accessKey'] = accessKey
        config.headers['X-validate-timestamp'] = timestamp
        config.headers['X-validate-nonceStr'] = nonce
        config.headers['X-validate-sign'] = sign

        if (config.headers['Content-Type'].indexOf('application/x-www-form-urlencoded') >= 0 && config.data) {
            config.data = qs.stringify(config.data)
        }
        // console.log(config)
        return config
    }, error => {
        // 对请求错误做些什么
        return Promise.reject(error)
    });

    request.interceptors.response.use(response => {
        // 对响应数据做点什么
        if (!response.data.code) {
          Message({
            message: "网络异常，请稍后重试",
            type: 'error',
            duration: 2000
          });
        }
        return response.data
    }, error => {
        // 对响应错误做点什么
        Message({
					message: "网络异常，请稍后重试",
					type: 'error',
					duration: 2000
				});
        return Promise.reject(error)
    })

    return request
}

function switchParams(params) {
    // console.log('switchParams', params)
    let paramsObj = {}
    for (let key in params) {
        let value = params[key]
        if (value !== '' && value !== null && value !== undefined) {
            paramsObj[key] = value
        }
    }
    return paramsObj
}


export const request = createRequest()





// WEBPACK FOOTER //
// ./src/common/request_talent.js